import axios from "axios";
import { useMutation } from "react-query";
import { ICreateCertification } from "../types";
import { END_POINT } from "config/environment";

export const createCertification = async (props: ICreateCertification) => {
  const url = `${END_POINT.BASE_URL}/v1/save-certification`;
  const config = {
    headers: {
      Accept: "application/json",
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${props.token}`,
    },
  };
  const data = new FormData();
  if (props.id != null) data.append("id", String(props.id));
  data.append("talent_id", String(props.talent_id));
  data.append("certification_id", props.certification_id);
  data.append("description", props.description);
  data.append("title", props.title);
  data.append("issuer", props.issuer);
  data.append("link", props.link);
  if (props.issued_date != null && props.issued_date !== "") {
    data.append("issued_date", String(props.issued_date));
  }
  if (props.file instanceof File) {
    data.append("file", props.file);
  }

  const response = await axios.post(url, data, config);
  return response;
};

export const useCreateCertification = () => {
  return useMutation(createCertification);
};
